import React, { useCallback, useState } from "react";
import { observer } from "mobx-react-lite";

import { CompactPicker } from "react-color";

import useModel from "../model/Model";

const colors = ["#fd2b32", "#f5800a", "#fdfe0e", "#3afc05", "#42ffff", "#1803ff", "#f508ff", "#9daaff"];

const ChangeColorBlock = () => {
    const model = useModel();

    const [color, setColor] = useState(model.changeColorPolygon?.color);
    const [openPicker, setOpenPicker] = useState(false);

    const handleColorChange = useCallback((color) => {
        setColor(color.hex);
    }, []);

    const applyColor = useCallback(() => {
        model.savePolygonChangeColor(color);
        setOpenPicker(false);
    }, [color]);

    return (
        <div id="changeColorBlock">
            <select value={model.changeColorPolygon?.id} onChange={(e) => model.colorPolygonChanged(+e.target.value)}>
                {model.polygons.map((item) => (
                    <option key={item} value={item}>
                        Polygon {item + 1}
                    </option>
                ))}
            </select>
            <div
                id="colorBox"
                style={{ background: model.changeColorPolygon?.color }}
                onClick={setOpenPicker.bind(null, true)}
            ></div>
            {openPicker && (
                <div id="ColorSelector">
                    <CompactPicker color={color} onChangeComplete={handleColorChange} colors={colors} />
                    
                    <div>
                        <button onClick={applyColor}>Save</button>
                        <button onClick={setOpenPicker.bind(null, false)}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default observer(ChangeColorBlock);
